import { RedirectionStateObject } from '../types';
import { tanstackUrlSearch, uriSafe } from '../utils';

export const spmRedirections: RedirectionStateObject = {
  'dashboard.spm': () => `/360/apm/services`,
  'dashboard.spm.services': () => `/360/apm/services`,
  'dashboard.spm.services.table': params => `/360/apm/services${tanstackUrlSearch(params)}`,
  'dashboard.spm.services.map': params => `/360/apm/services${tanstackUrlSearch({ viewMode: 'map', ...params })}`,
  'dashboard.spm.service-overview': ({ serviceName, ...params }) =>
    `/360/apm/services/${uriSafe(serviceName)}${tanstackUrlSearch(params)}`,
  'dashboard.spm.operation-overview': ({ serviceName, operation, ...params }) =>
    `/360/apm/services/${uriSafe(serviceName)}/operations/${uriSafe(operation)}${tanstackUrlSearch(params)}`,
  'dashboard.real-user-monitoring': () => `/360/apm/services`,
};
